<template>
  <div id="message">
   
        <outbox :tabindex="tabindex"></outbox>
     
  </div>
</template>

<script>
  import outbox from '@/components/message/child/outbox';
  export default {
    name: "message",
    components:{
     
      'outbox':outbox,
    },
    data() {
      return {
        tabindex:"0",
      }
    },
    created() {
      this.$global.activeMenu = ''; //不激活左侧
    },
    mounted() {

    },
    methods: {
      setIndex(e){
        let me = this;
        me.tabindex = e.index;
      }
    }
  }
</script>

<style lang="css">
  @import '../../assets/less/global.less';
  @import '../../assets/css/icon.css';
  @import '../../assets/css/app.css';
  .el-tooltip__popper{font-size: 14px; max-width:60%; }   
</style>



// WEBPACK FOOTER //
// src/components/message/message.vue